var _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clocking in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.07,4.65H2.93a.61.61,0,0,0-.61.61v9.13a.61.61,0,0,0,.61.61h9.14a.61.61,0,0,0,.61-.61V5.26A.61.61,0,0,0,12.07,4.65ZM7.5,13.78a4,4,0,1,1,4-4A4,4,0,0,1,7.5,13.78Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13.04,
    r: 0.33
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6.69,
    r: 0.33
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.67,
    cy: 9.86,
    r: 0.33
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.33,
    cy: 10.03,
    r: 0.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67,9.88V10a.15.15,0,0,1-.15.15H7.29V7.49a.15.15,0,0,1,.15-.15h.15a.15.15,0,0,1,.14.15V9.73H9.52A.15.15,0,0,1,9.67,9.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61,0a.91.91,0,0,1-1,.84A.89.89,0,0,1,6.7,0H5.55V4.2h4.2V0Zm-1,3.53-1.15-2H8.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockin);
export default __webpack_public_path__ + "static/media/clockin.d9ae31ae80bf20c04013a39307c3e592.svg";
export { ForwardRef as ReactComponent };